import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"
import store from "./store/index"
import API from '@/api/index'
import Vuelidate from 'vuelidate'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import _ from 'lodash'
import Storage from 'vue-web-storage'
import Toasted from 'vue-toasted'
import PageHeader from "./components/PageHeader"
import PageFooter from "./components/PageFooter"
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ko'
import 'element-ui/lib/theme-chalk/index.css'
import 'summernote/dist/summernote-lite.js';
import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/lang/summernote-ko-KR.min';
import moment from 'moment';
import VueMomentJs from 'vue-momentjs';

window.$ = require('jquery');

// plugins
Vue.use(API)
Vue.use(Vuelidate)
Vue.use(Toasted)
Vue.use(Storage, {
  prefix: 'com.dgmonglab.safetyapp',
  drivers: ['session','local'],
})

Vue.use(VueMomentJs, moment);
Vue.use(ElementUI, {locale});
Object.defineProperty(Vue.prototype, '$_', { value: _ })
Vue.config.productionTip = false

// global components
Vue.component("page-header", PageHeader)
Vue.component("page-footer", PageFooter)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
